export const buildTags = ({immCategories, currentStepCategory, currentStepSubCategory})=> {

    const categories = immCategories.get(currentStepCategory).toJS()
    const subCategories = categories.subCategories[currentStepSubCategory]
    const categoryTag = categories.categoryTag
    const subCategoryTag = subCategories.subcategoryTag
    const step = subCategories.step
    const sections = subCategories.sections
    const questions = sections.flatMap(s => s.questions)
    const answers = questions.flatMap(q => q.answer)
    const selectedAnswersOfSection = answers.filter(ans => ans.selected === 'S')
    const questionsTag = questions.map(q => ((`${q.id}_${q.questionTag}`)))
    const answersTag =  selectedAnswersOfSection.map((ans) => (`${ans.id}_${ans.answerTag.replace("shortResponse", "")}`))

    return {
        currentQuestionsTag: questionsTag.join('|'),
        currentAnswersTag: answersTag.join('|'),
        currentCategoryTag: categoryTag,
        currentSubCategoryTag: subCategoryTag,
        currentStep: step
    }

}